<template>
  <section class="authContainer bg-custom">
    <div class="main-popup visible shadow-custom bg-white rounded-lg pb-4">
      <div class="popup-header text-center">
        <div class="content">Sign in to your account</div>
        <router-link to="/" class="d-block">
          <img
            class="img-fluid"
            src="/assets/images/brand1.png"
            width="180px"
            id="brand-logo"
          />
        </router-link>
      </div>
      <div class="popup-content">
        <div
          v-if="alert.message"
          :key="Math.random()"
          :class="'rounded-0 mb-2 text-center alert ' + alert.type"
        >
          {{ alert.message }}
        </div>
        <div
          v-else
          class="notifier mb-2 position-relative text-center bg-light p-2"
        >
          Please enter your valid credentials to continue.
        </div>
        <form action="#" class="pt-1 px-4">
          <div class="form-content pt-0 w-100">
            <div class="form-group">
              <input
                type="text"
                placeholder="Enter your phone number"
                id="phone"
                name="phone"
                class="form-control"
                v-validate="'required|digits:11'"
                :class="{
                  'is-invalid': submitted && errors.has('phone')
                }"
                v-model="username"
              />
              <div
                v-if="submitted && errors.has('phone')"
                class="small invalid-feedback"
              >
                {{ errors.first("phone") }}
              </div>
            </div>
            <div class="form-group">
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Enter your password"
                class="form-control"
                v-validate="{ required: true, min: 6 }"
                :class="{ 'is-invalid': submitted && errors.has('password') }"
                v-model="password"
              />
              <div
                v-if="submitted && errors.has('password')"
                class="small invalid-feedback"
              >
                {{ errors.first("password") }}
              </div>
            </div>
            <div class="form-group d-flex">
              <div class="custom-control custom-checkbox my-1 mr-sm-2 ml-2">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="remember-me"
                />
                <label class="custom-control-label" for="remember-me"
                  >Remember me</label
                >
              </div>
              <router-link
                to="/forgotpassword"
                class="d-inline-block ml-auto primary_link"
                >Forgot password?</router-link
              >
            </div>
            <div class="form-group">
              <button
                class="btn btn-dark btn-sm btn-pill btn-block"
                type="submit"
                :disabled="status.loggingIn"
                @click="handleSubmit"
              >
                <span v-if="status.loggingIn" class="donutSpinner"></span>
                <span v-else>Login into your Account</span>
              </button>
            </div>
            <div class="text-center">
              New User?
              <router-link to="/signup" class="d-inline-block primary_link ml-1"
                >Create a Free Account</router-link
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Login",

  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Login",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  data() {
    return {
      username: "",
      password: "",
      submitted: false
    };
  },
  created() {
    this.clearAlert();
  },
  computed: {
    ...mapState("account", ["status"]),
    ...mapState({
      alert: state => state.alert
    })
  },
  methods: {
    ...mapActions("account", ["login"]),
    ...mapActions({
      clearAlert: "alert/clear"
    }),

    handleSubmit(e) {
      e.preventDefault();

      this.submitted = true;
      const { username, password } = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.login({ username, password });
        }
      });
    }
  }
};
</script>
